import { render, staticRenderFns } from "./UploadFilesTable.vue?vue&type=template&id=e11b8810&scoped=true&"
import script from "./UploadFilesTable.vue?vue&type=script&lang=js&"
export * from "./UploadFilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11b8810",
  null
  
)

export default component.exports